import { FileDoneOutlined, HistoryOutlined } from "@ant-design/icons";
import { Tabs, Typography } from "antd";
import React, { useState } from "react";

import VoidCheckHistoryPanel from "./component/VoidCheckHistoryPanel";
import VoidCheckPanel from "./component/VoidCheckPanel";
import "./component/index.scss";

const { Text, Title } = Typography;

/** Void Check workspace: current checks and prior void events share one screen. */
const VoidCheck = () => {
  const [historyRefreshKey, setHistoryRefreshKey] = useState(0);

  return (
    <main className="void-check-page">
      <header className="void-check-page-header">
        <div>
          <Title level={4}>Void Check</Title>
          <Text>
            Void an issued check, create its replacement, or review a prior void
            event.
          </Text>
        </div>
      </header>

      <Tabs
        className="void-check-tabs"
        defaultActiveKey="current"
        items={[
          {
            key: "current",
            label: (
              <span>
                <FileDoneOutlined /> Current checks
              </span>
            ),
            children: (
              <VoidCheckPanel
                onOperationSuccess={() =>
                  setHistoryRefreshKey((current) => current + 1)
                }
              />
            ),
          },
          {
            key: "history",
            label: (
              <span>
                <HistoryOutlined /> Voided check history
              </span>
            ),
            children: <VoidCheckHistoryPanel refreshKey={historyRefreshKey} />,
          },
        ]}
      />
    </main>
  );
};

export default VoidCheck;
